import { getBaseURL } from 'service/env'
import * as service from 'service'
import axios from 'axios'

const baseURL = getBaseURL('dponet')

const uploadLogo = async ({ organizationId = '', logo }) => {
  var formData = new FormData()

  formData.append('logo', logo)

  const config = {
    headers: {
      'Content-Type': 'multipart/form-data',
      'Content-Disposition': 'attachment',
      Authorization: service.dponet.auth.getToken(),
    },
  }

  return await axios({
    method: 'POST',
    url: `${baseURL}/advisors/organizations/${organizationId}/add_logo`,
    data: formData,
    ...config,
  })
}

const organizations = {
  uploadLogo,
}

export default organizations
